import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue";
var _hoisted_1 = {
  class: "file-panel"
};
var _hoisted_2 = {
  class: "file-list"
};
var _hoisted_3 = ["onClick"];
var _hoisted_4 = ["src"];
var _hoisted_5 = {
  class: "name"
};
var _hoisted_6 = {
  class: "file-item-right"
};
var _hoisted_7 = {
  class: "main"
};
var _hoisted_8 = {
  class: "file-info"
};
var _hoisted_9 = ["src"];
var _hoisted_10 = {
  class: "file-panel-main"
};
var _hoisted_11 = ["src"];
var _hoisted_12 = {
  class: "dialog-file"
};
import SideBar from './common/SideBar';
import Empty from './common/Empty';
import UploadFile from './common/UploadFile';
import CanvasPanel from './common/CanvasPanel';
import CanvasTool from './common/CanvasTool/index';
import ChangeRole from './common/ChangeRole';
import Paging from './common/Paging';

/* 工具 */
import { ref, onMounted, provide, inject, computed, nextTick } from 'vue';
import { MessagePlugin, DialogPlugin } from 'tdesign-vue-next';
import { LEFT_BAR_MAP } from '../const';
import { operationRecord } from './common/common';
import { fileClass, imgCoverMap } from '@/utils/index';
import { getStore } from '@/util/store';
import useSocket from './common/useSocket.js';

/* api */
import { getResearchFile, delResearchFile, addResearchFile, getFileCanvas, addEditFileDraw, removeFileDraw } from '@/api/index-bei-discuss';

/* 变量 */

export default {
  __name: 'File',
  setup: function setup(__props) {
    var _getStore, _getStore2;
    /* 组件 */
    var imgRef = ref();
    var imgBoxRef = ref();
    var canvasPanelRef = ref();
    var userId = (_getStore = getStore({
      name: 'userInfo'
    })) === null || _getStore === void 0 ? void 0 : _getStore.id;
    var userName = (_getStore2 = getStore({
      name: 'userInfo'
    })) === null || _getStore2 === void 0 ? void 0 : _getStore2.name;
    var discussId = inject('discussId');
    var discussInfo = inject('discussInfo');
    var addFileVisible = ref(false);
    var fileName = ref('');
    var fileList = ref([]);
    var confirmLoading = ref(false);
    var fileListData = ref([]); // 文件列表
    var currentImgList = ref([]); // 当前文件的图片列表（包含currentImgInfo）
    var currentImgInfo = ref({}); // 当前图片信息(单张)
    var currentImgPage = ref(0); // 当前图片页码
    var roleId = ref(userId);
    var canvasShow = ref(false);
    var canvasW = ref(0);
    var canvasH = ref(0);
    var canvasObj = ref({});
    var _useSocket = useSocket(31, discussId.value),
      socketSend = _useSocket.socketSend,
      socketReceive = _useSocket.socketReceive;

    /* 计算属性 */
    // 当前是否为创建者
    var isCreator = computed(function () {
      var _discussInfo$value;
      return userId === ((_discussInfo$value = discussInfo.value) === null || _discussInfo$value === void 0 ? void 0 : _discussInfo$value.creatorId);
    });

    /* 传递数据 */
    provide('annotation-type', 'file');
    provide('annotation-info', currentImgInfo);
    provide('annotation-roleId', roleId);

    /* 事件 */
    // 点击切换侧边栏
    var sideBarChange = function sideBarChange(item) {
      if (item.click === 'fileAdd') {
        addFileVisible.value = true;
      }
    };

    // 添加弹窗关闭
    var addFileClose = function addFileClose() {
      fileName.value = '';
      fileList.value = [];
    };

    // 添加文件
    var addFileOk = function addFileOk() {
      if (!fileName.value) {
        MessagePlugin.closeAll();
        MessagePlugin.warning('请输入资料名称');
      } else if (fileList.value.length === 0) {
        MessagePlugin.closeAll();
        MessagePlugin.warning('请上传文件');
      } else {
        confirmLoading.value = true;
        var fileData = fileList.value[0];
        var fileUrl = (fileData === null || fileData === void 0 ? void 0 : fileData.url) || '';
        var firstPointIndex = fileUrl.indexOf('.');
        var bucketName = fileUrl.slice(8, firstPointIndex);
        var restUrl = fileUrl.slice(firstPointIndex);
        var firstSlashIndex = restUrl.indexOf('/');
        var ossName = restUrl.slice(firstSlashIndex + 1);
        var data = {
          discussId: discussId.value,
          fileName: fileName.value,
          fileSuffix: fileData.suffix,
          ossName: ossName,
          bucketName: bucketName
        };
        addResearchFile(data).then(function (res) {
          if (res.data.code === 0) {
            confirmLoading.value = false;
            addFileVisible.value = false;
            fileName.value = '';
            fileList.value = [];
            MessagePlugin.success('文件添加成功！');
          }
        });
      }
    };

    // 格式化文件列表
    var formatData = function formatData(list) {
      var res = JSON.parse(JSON.stringify(list));
      res.forEach(function (item) {
        var _item$pngList;
        if ((_item$pngList = item.pngList) !== null && _item$pngList !== void 0 && _item$pngList.length) {
          item.pngList = item.pngList.map(function (e) {
            return {
              id: item.id,
              name: item.fileName,
              suffix: e.url.slice(e.url.lastIndexOf('.') + 1),
              url: e.url,
              imgId: e.documentItemId
            };
          });
        }
      });
      return res;
    };

    // 获取文件列表
    var getList = function getList() {
      getResearchFile(discussId.value).then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(res) {
          var index, firstItem;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                if (res.data.code === 0) {
                  fileListData.value = formatData(res.data.data || []);
                  if (fileListData.value.length) {
                    index = fileListData.value.findIndex(function (e) {
                      var _currentImgInfo$value;
                      return e.id === ((_currentImgInfo$value = currentImgInfo.value) === null || _currentImgInfo$value === void 0 ? void 0 : _currentImgInfo$value.id);
                    });
                    if (index === -1) {
                      firstItem = fileListData.value.find(function (e) {
                        return e.pictureStatus;
                      });
                      fileChange(firstItem);
                    }
                  } else {
                    currentImgList.value = [];
                    currentImgInfo.value = {};
                  }
                }
              case 1:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    };

    // 切换文件
    var fileChange = function fileChange(item) {
      var _currentImgInfo$value2;
      if (((_currentImgInfo$value2 = currentImgInfo.value) === null || _currentImgInfo$value2 === void 0 ? void 0 : _currentImgInfo$value2.id) === item.id) return;
      canvasShow.value = false;
      operationRecord(discussId.value, '查看文件');
      if (item.pictureStatus) {
        var _item$pngList2;
        // 文件已转为图片列表
        currentImgList.value = item.pngList || [];
        currentImgInfo.value = ((_item$pngList2 = item.pngList) === null || _item$pngList2 === void 0 ? void 0 : _item$pngList2[0]) || {};
        currentImgPage.value = 1;
      }
    };

    // 文件删除
    var fileDelete = function fileDelete(id) {
      var dialog = DialogPlugin({
        header: '删除文件',
        body: '是否删除该文件',
        theme: 'danger',
        cancelBtn: '取消',
        confirmBtn: {
          content: '确认',
          theme: 'danger'
        },
        onConfirm: function onConfirm() {
          delResearchFile(discussId.value, id).then(function (res) {
            if (res.data.code === 0) {
              MessagePlugin.success('删除成功！');
              getList();
              dialog.destroy();
            }
          });
        }
      });
    };

    // 文件图片加载完成
    var imgLoad = function imgLoad() {
      var imgW = imgRef.value.offsetWidth || 0;
      var imgH = imgRef.value.offsetHeight || 0;
      var boxH = imgBoxRef.value.offsetHeight || 0;
      if (imgH < boxH) {
        imgBoxRef.value.classList.add('flex-center');
      } else {
        imgBoxRef.value.classList.remove('flex-center');
      }
      canvasW.value = imgW;
      canvasH.value = imgH;
      canvasShow.value = true;
      nextTick(function () {
        getCanvas();
      });
    };

    // 获取画布内容
    var getCanvas = function getCanvas() {
      return new Promise(function (resolve) {
        var _canvasObj$value, _currentImgInfo$value3, _currentImgInfo$value4;
        (_canvasObj$value = canvasObj.value) === null || _canvasObj$value === void 0 || _canvasObj$value.clear();
        var data = {
          discussId: discussId.value,
          // 教研id
          documentId: (_currentImgInfo$value3 = currentImgInfo.value) === null || _currentImgInfo$value3 === void 0 ? void 0 : _currentImgInfo$value3.id,
          // 文件id
          documentItemId: (_currentImgInfo$value4 = currentImgInfo.value) === null || _currentImgInfo$value4 === void 0 ? void 0 : _currentImgInfo$value4.imgId,
          // 文件图片列表中的某一图片id
          viewerId: roleId.value // 视角id
        };
        getFileCanvas(data).then(function (res) {
          if (res.data.code === 0) {
            var _canvasPanelRef$value;
            (_canvasPanelRef$value = canvasPanelRef.value) === null || _canvasPanelRef$value === void 0 || _canvasPanelRef$value.addElements(res.data.data || []);
            resolve();
          }
        });
      });
    };

    // 视角切换
    var roleChange = function roleChange() {
      getCanvas();
    };

    // 切换分页
    var switchPage = function switchPage() {
      currentImgInfo.value = currentImgList.value[currentImgPage.value - 1];
      getCanvas();
    };

    // 画布工具切换
    var toolChange = function toolChange(toolInfo) {
      var _canvasPanelRef$value2;
      (_canvasPanelRef$value2 = canvasPanelRef.value) === null || _canvasPanelRef$value2 === void 0 || _canvasPanelRef$value2.toolChange(toolInfo);
    };

    // 画布内容改变
    var canvasChange = function canvasChange(data) {
      var addOpts = ['penciladd', 'textadd', 'textedit', 'markadd'];
      var delOpts = ['pencildel', 'textdel', 'markdel'];
      var api = null;
      if (addOpts.includes(data.optType)) {
        var _currentImgInfo$value5, _currentImgInfo$value6;
        var params = {
          discussId: discussId.value,
          documentId: (_currentImgInfo$value5 = currentImgInfo.value) === null || _currentImgInfo$value5 === void 0 ? void 0 : _currentImgInfo$value5.id,
          // 文件id
          documentItemId: (_currentImgInfo$value6 = currentImgInfo.value) === null || _currentImgInfo$value6 === void 0 ? void 0 : _currentImgInfo$value6.imgId,
          // 文件图片列表中的某一图片id
          drawId: data.drawId,
          drawContent: data.drawContent,
          viewerId: roleId.value,
          ownerId: userId
        };
        api = addEditFileDraw(params);
      } else if (delOpts.includes(data.optType)) {
        api = removeFileDraw(discussId.value, data.drawId);
      }
      if (api) {
        api.then(function (res) {
          if (res.data.code === 0) {
            var _currentImgInfo$value7, _currentImgInfo$value8;
            var txt = '';
            if (data.optType === 'penciladd') {
              txt = '文件—使用画笔';
            } else if (data.optType === 'textadd') {
              txt = '文件—使用文本框';
            } else if (data.optType === 'pencildel' || data.optType === 'textdel') {
              txt = '文件—使用橡皮擦';
            }
            txt && operationRecord(discussId.value, txt);
            socketSend({
              msgType: 12,
              bizType: 31,
              userId: userId,
              userName: userName,
              bizId: discussId.value,
              optType: data.optType,
              optData: {
                discussId: discussId.value,
                documentId: (_currentImgInfo$value7 = currentImgInfo.value) === null || _currentImgInfo$value7 === void 0 ? void 0 : _currentImgInfo$value7.id,
                documentItemId: (_currentImgInfo$value8 = currentImgInfo.value) === null || _currentImgInfo$value8 === void 0 ? void 0 : _currentImgInfo$value8.imgId,
                viewerId: roleId.value
              }
            });
          }
        });
      }
    };

    /* 钩子 */
    onMounted(function () {
      socketReceive(function (data) {
        if (data.optData) {
          var _currentImgInfo$value9, _currentImgInfo$value0;
          var ids = JSON.parse(data.optData);
          var _discussId = ids.discussId,
            documentId = ids.documentId,
            documentItemId = ids.documentItemId,
            viewerId = ids.viewerId;
          var bool1 = Number(_discussId) === Number(_discussId.value);
          var bool2 = Number(documentId) === Number((_currentImgInfo$value9 = currentImgInfo.value) === null || _currentImgInfo$value9 === void 0 ? void 0 : _currentImgInfo$value9.id);
          var bool3 = Number(documentItemId) === Number((_currentImgInfo$value0 = currentImgInfo.value) === null || _currentImgInfo$value0 === void 0 ? void 0 : _currentImgInfo$value0.imgId);
          var bool4 = Number(viewerId) === Number(roleId.value);
          if (bool1 && bool2 && bool3 && bool4) {
            getCanvas();
          }
        }
      });
      getList();
    });
    return function (_ctx, _cache) {
      var _currentImgInfo$value1, _currentImgList$value;
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_t_loading = _resolveComponent("t-loading");
      var _component_t_input = _resolveComponent("t-input");
      var _component_t_dialog = _resolveComponent("t-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(SideBar), {
        barList: _unref(LEFT_BAR_MAP)['file'],
        onTabChange: sideBarChange,
        onHoverEnter: getList
      }, {
        hoverList: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileListData.value, function (item) {
            return _openBlock(), _createElementBlock("div", {
              key: item.id,
              class: "file-item",
              onClick: function onClick($event) {
                return fileChange(item);
              }
            }, [_createElementVNode("img", {
              width: "18",
              height: "24",
              src: _unref(imgCoverMap)[_unref(fileClass)(item.fileSuffix)]
            }, null, 8, _hoisted_4), _createElementVNode("span", _hoisted_5, _toDisplayString(item.fileName), 1), _createElementVNode("div", _hoisted_6, [item.pictureStatus && isCreator.value ? (_openBlock(), _createBlock(_component_svg_icon, {
              key: 0,
              name: "delete",
              onClick: _withModifiers(function ($event) {
                return fileDelete(item.id);
              }, ["stop"])
            }, null, 8, ["onClick"])) : _createCommentVNode("", true), !item.pictureStatus ? (_openBlock(), _createBlock(_component_t_loading, {
              key: 1,
              text: "转换中",
              size: "small"
            })) : _createCommentVNode("", true)])], 8, _hoisted_3);
          }), 128))])];
        }),
        _: 1
      }, 8, ["barList"]), _createElementVNode("div", _hoisted_7, [(_currentImgInfo$value1 = currentImgInfo.value) !== null && _currentImgInfo$value1 !== void 0 && _currentImgInfo$value1.imgId ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref_key: "imgBoxRef",
        ref: imgBoxRef,
        class: "file-panel-box"
      }, [_createElementVNode("div", _hoisted_8, [_createElementVNode("img", {
        src: _unref(imgCoverMap)[_unref(fileClass)(currentImgInfo.value.suffix)]
      }, null, 8, _hoisted_9), _createElementVNode("span", null, _toDisplayString(currentImgInfo.value.name), 1)]), _createElementVNode("div", _hoisted_10, [_createElementVNode("img", {
        ref_key: "imgRef",
        ref: imgRef,
        src: currentImgInfo.value.url,
        draggable: "false",
        onLoad: imgLoad
      }, null, 40, _hoisted_11), canvasShow.value ? (_openBlock(), _createBlock(_unref(CanvasPanel), {
        key: 0,
        ref_key: "canvasPanelRef",
        ref: canvasPanelRef,
        canvasObj: canvasObj.value,
        "onUpdate:canvasObj": _cache[0] || (_cache[0] = function ($event) {
          return canvasObj.value = $event;
        }),
        w: canvasW.value,
        h: canvasH.value,
        onChange: canvasChange
      }, null, 8, ["canvasObj", "w", "h"])) : _createCommentVNode("", true)]), _createVNode(_unref(CanvasTool), {
        class: "tool",
        tools: ['brush', 'rubber', 'text', 'note'],
        onChange: toolChange
      }), _createVNode(_unref(ChangeRole), {
        modelValue: roleId.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
          return roleId.value = $event;
        }),
        onChange: roleChange
      }, null, 8, ["modelValue"]), _createVNode(_unref(Paging), {
        current: currentImgPage.value,
        "onUpdate:current": _cache[2] || (_cache[2] = function ($event) {
          return currentImgPage.value = $event;
        }),
        total: (_currentImgList$value = currentImgList.value) === null || _currentImgList$value === void 0 ? void 0 : _currentImgList$value.length,
        justSwitch: "",
        onSwitchPage: switchPage
      }, null, 8, ["current", "total"])], 512)) : (_openBlock(), _createBlock(_unref(Empty), {
        key: 1,
        name: "file"
      }))]), _createVNode(_component_t_dialog, {
        header: "添加文件",
        visible: addFileVisible.value,
        "onUpdate:visible": _cache[5] || (_cache[5] = function ($event) {
          return addFileVisible.value = $event;
        }),
        destroyOnClose: "",
        closeOnEscKeydown: false,
        closeOnOverlayClick: false,
        confirmLoading: confirmLoading.value,
        onConfirm: addFileOk,
        onClose: addFileClose
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_12, [_cache[6] || (_cache[6] = _createElementVNode("div", {
            class: "dialog-file-item"
          }, [_createElementVNode("i", {
            class: "red"
          }, "*"), _createTextVNode("资料名称")], -1)), _createVNode(_component_t_input, {
            class: "dialog-file-item",
            value: fileName.value,
            "onUpdate:value": _cache[3] || (_cache[3] = function ($event) {
              return fileName.value = $event;
            }),
            "aria-placeholder": "请输入名称",
            maxlength: "15"
          }, null, 8, ["value"]), _cache[7] || (_cache[7] = _createElementVNode("div", {
            class: "dialog-file-item"
          }, [_createElementVNode("i", {
            class: "red"
          }, "*"), _createTextVNode("上传文件 "), _createElementVNode("i", {
            class: "grey"
          }, "（只支持ppt、pdf、word格式，10M以内）")], -1)), _createVNode(_unref(UploadFile), {
            list: fileList.value,
            "onUpdate:list": _cache[4] || (_cache[4] = function ($event) {
              return fileList.value = $event;
            }),
            accept: ".ppt, .pptx, .pdf, .doc, .docx",
            maxSize: {
              size: 10,
              unit: 'MB',
              message: '文件大小不超过10MB'
            }
          }, null, 8, ["list"])])];
        }),
        _: 1
      }, 8, ["visible", "confirmLoading"])]);
    };
  }
};